










import { Component, Vue } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import CorporationConfigsData from '@/components/Admin/Panels/CorporationConfigsData.vue';

@Component({
    components: {
        CorporationConfigsData,
    },
})

export default class CorporationConfigs extends Vue {
    constructor() {
        super();
    }

    get currentCorporation() {
        return this.$store.getters['Corporations/getCurrentCorporation'];
    }

    public mounted() {
        this.$store.dispatch(Actions.FETCH_ADMIN_CURRENT_CORPORATION);
    }

    public beforeDestroy() {
        this.$store.commit(Mutations.SET_ADMIN_CURRENT_CORPORATION, null);
    }
}
